// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__2pFED","actionButtons":"styles_actionButtons__1BQp-"};